<template>
  <div :class="classes()">
    <div :class="`${el}__row ${el}__row--border`">
      <div :class="`${el}__col ${el}__col--17`">
        <Copy element="span" color="primaryBlue" bold>
          {{ $t('careLevelCalculator.analysis.pflegegradeinstufung.careLevel') }}
        </Copy>
      </div>
      <div :class="`${el}__col ${el}__col--8 ${el}__col--center`">
        <div :class="{ [`${el}__square`]: true, [`${el}__square--active`]: pflegegrad === 0 }">
          ?
        </div>
      </div>
      <div v-for="item in 5" :key="item" :class="`${el}__col ${el}__col--15 ${el}__col--center`">
        <div :class="{ [`${el}__square`]: true, [`${el}__square--active`]: item === pflegegrad }">
          {{ $t('careLevelCalculator.analysis.pflegegradeinstufung.pg', { value: item }) }}
        </div>
      </div>
    </div>

    <div v-if="$matchMedia.l" :class="`${el}__row`">
      <div :class="`${el}__col ${el}__col--17`">
        <div class="u-margin__top--2">
          <Copy element="span">
            {{ $t('careLevelCalculator.analysis.pflegegradeinstufung.copy') }}
          </Copy>
        </div>
      </div>
      <div :class="`${el}__col ${el}__col--8 ${el}__col--center`"></div>
      <div v-for="item in 5" :key="item" :class="`${el}__col ${el}__col--15 ${el}__col--center`">
        <div :class="`${el}__innerCol`">
          <Copy element="div" bold centered>{{ descriptions[item - 1] }}</Copy>

          <Copy v-if="descriptions.length === item" size="s" color="tertiaryLight" centered>
            {{ $t('careLevelCalculator.analysis.pflegegradeinstufung.info') }}
          </Copy>
        </div>
      </div>
    </div>

    <div :class="`${el}__row`">
      <div :class="`${el}__progessBar`"></div>
      <div :class="`${el}__col ${el}__col--17`">
        {{ $t('careLevelCalculator.analysis.pflegegradeinstufung.pointsCopy') }}
      </div>
      <div
        v-for="item in 6"
        :key="item"
        :class="{
          [`${el}__col`]: true,
          [`${el}__col--8`]: item === 1,
          [`${el}__col--15`]: item > 1,
          [`${el}__progess`]: true,
          [`${el}__progess--animatable`]: item - 1 === pflegegrad,
        }"
        :data-content="formatNumber(points[item - 1])"
        ref="pointElement"
      >
        <Copy
          v-if="item - 1 === pflegegrad"
          element="div"
          noWrap
          :staticClass="`${el}__indicator`"
          color="neutral10"
          bold
        >
          {{
            $t('careLevelCalculator.analysis.pflegegradeinstufung.points', {
              value: formatNumber(gewichtetePunkte),
            })
          }}
        </Copy>
      </div>
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';

import careLevelMixin from '@/mixins/careLevel';

import { formatNumber } from '@/helpers/formatter';

export default {
  name: 'CareLevelResultTableDesktop',
  mixins: [careLevelMixin],
  props: {
    points: Array,
  },
  components: {
    Copy,
  },
  computed: {
    gewichtetePunkte() {
      const { gewichtetePunkte } = this.getCalculatedCareLevel();
      return gewichtetePunkte;
    },

    pflegegrad() {
      return this.calculatedCareLevel || 0;
    },
  },
  data() {
    return {
      formatNumber,
      el: 'c-careLevelResultTableDesktop',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
      descriptions: this.$t('careLevelCalculator.analysis.pflegegradeinstufung.labels'),
    };
  },
  mounted() {
    this.setIndicator();
  },
  updated() {
    this.setIndicator();
  },
  methods: {
    setIndicator() {
      for (let i = 0; i < 6; i++) {
        let w = i > this.pflegegrad ? '0%' : '100%';

        if (i === this.pflegegrad) {
          const start = this.points[this.pflegegrad];
          const end = this.points[this.pflegegrad + 1];
          const percentage = (100 / (end - start)) * (this.gewichtetePunkte - start);
          w = `${percentage}%`;
        }

        this.$refs.pointElement[i].style.setProperty('--width', w);

        const indicator = this.$refs.pointElement[i].querySelector(`.${this.el}__indicator`);
        if (indicator) {
          indicator.style.setProperty('--left', w);
        }
      }
    },
  },
};
</script>
